import GroupService from '../../service/group';

const Action = {
    ADD_GROUP_CURRENT_POINT: "ADD_GROUP_CURRENT_POINT",
    GET_GROUP: "GET_GROUP",
    GET_GROUPS: "GET_GROUPS",
    GET_GROUP_LEFT_CAN_USE: "GET_GROUP_LEFT_CAN_USE",
    NEW_GROUP: "NEW_GROUP",
    UPDATE_GROUP: "UPDATE_GROUP",
    UPDATE_GROUP_MAIN_VIP: "UPDATE_GROUP_MAIN_VIP",
};

const ActionCreator = {
    addGroupCurrentPoint({groupId, point}) {
        return async (dispatch) => {
            try {
                const group = await GroupService.addPoint({groupId, point});
                dispatch({type: Action.ADD_GROUP_CURRENT_POINT, group});
                return group;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getGroup(groupId) {
        return async (dispatch) => {
            try {
                const group = await GroupService.findById(groupId);
                dispatch({type: Action.GET_GROUP, group});
                await dispatch(ActionCreator.getGroupLeftCanUse(groupId));
                return group;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getGroups() {
        return async (dispatch) => {
            try {
                const groups = [];
                dispatch({type: Action.GET_GROUPS, groups});
                return groups;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getGroupLeftCanUse(groupId) {
        return async (dispatch) => {
            try {
                const groupLeftCanUse = await GroupService.getGroupLeftCanUse(groupId);
                dispatch({type: Action.GET_GROUP_LEFT_CAN_USE, leftCanUse: groupLeftCanUse});
                return groupLeftCanUse;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    addGroup(group) {
        return async (dispatch) => {
            try {
                const newGroup = await GroupService.add(group);
                dispatch({type: Action.NEW_GROUP, group: newGroup});
                return newGroup;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    deleteGroup(groupId) {
        return async (dispatch) => {
            try {
                return await GroupService.deleteById(groupId);
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    changePlan({groupId, pricePlanId}) {
        return async (dispatch) => {
            try {
                await GroupService.changePlan({groupId, pricePlanId});
                return dispatch(ActionCreator.getGroup(groupId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    updateGroup(group) {
        return async (dispatch) => {
            try {
                const newGroup = await GroupService.update({...group, expire_date: undefined, join_date: undefined});
                dispatch({type: Action.UPDATE_GROUP, group: newGroup});
                return newGroup;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    updateMainVip(mainVip, group) {
        return async (dispatch) => {
            try {
                const newMainVip = await GroupService.updateMainVip(mainVip, group);
                dispatch({type: Action.UPDATE_GROUP_MAIN_VIP, mainVip: newMainVip});
                return newMainVip;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    plusUseRecord({missionTypeId, points, groupId, groupType, point_action}) {
        // period (加點頻率) => 可選擇項為 1天 . 1個月 . 1年 , 0 代表立即加點

        const period_in_milliseconds = (groupType.label === 'company') ? 24 * 60 * 60 * 1000 : 0;
        const newPoint = (point_action === '加點') ? points : points * (-1);

        return async (dispatch) => {
            try {
                await GroupService.plusUseRecord({groupId, missionTypeId, period_in_milliseconds, points: newPoint});
                return dispatch(ActionCreator.getGroup(groupId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
};

const initialState = {
    groups: [],
    group: {},
    leftCanUse: []
};

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.ADD_GROUP_CURRENT_POINT:
        case Action.GET_GROUP:
        case Action.NEW_GROUP:
        case Action.UPDATE_GROUP:
            return {
                ...state,
                group: action.group
            };
        case Action.UPDATE_GROUP_MAIN_VIP:
            return {
                ...state,
                group: {...state.group, main_vip: action.mainVip}
            };
        case Action.GET_GROUPS:
            return {
                ...state,
                groups: action.groups
            };
        case Action.GET_GROUP_LEFT_CAN_USE:
            return {
                ...state,
                leftCanUse: action.leftCanUse
            };
        default: {
            return state;
        }
    }
};

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/group.js